import React, { forwardRef } from 'react'
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons'
import { Input } from 'antd'
import './index.css'

interface FormInputProps {
  Form: any;
  label?: React.ReactNode;
  name?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  rules?: any[];
  formItemStyles?: React.CSSProperties;
  validateStatus?: '' | 'success' | 'warning' | 'error' | 'validating';
  help?: React.ReactNode;
  onFocusHandler?: () => void;
  onBlurHandler?: () => void;
  autoFocus?: boolean;
  subTextCustom?: React.ReactNode;
  disabled?: boolean;
  smallText?: boolean;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  value?: string;
  customFormError?: React.ReactNode;
  type?: string;
  [key: string]: any;
}

const FormInput = forwardRef<any, FormInputProps>(
  (
    {
      Form,
      label,
      name,
      onChange,
      placeholder,
      rules = [],
      formItemStyles = {},
      validateStatus,
      help,
      onFocusHandler = () => {},
      onBlurHandler = () => {},
      autoFocus = false,
      subTextCustom = '',
      disabled = false,
      smallText = false,
      onKeyDown = () => {},
      value = undefined,
      customFormError = false,
      type = 'text',
      ...extra
    },
    ref,
  ) => {
    let formItemClasses = 'v2FormInput'
    if (subTextCustom) {
      formItemClasses = 'v2FormInput withSubtextCustom'
    }
    if (disabled) {
      formItemClasses = 'v2FormInput disabledInput'
    }
    if (smallText) {
      formItemClasses = 'v2FormInput smallText'
    }
    return (
      <div className="__formInputWrapper">
        <Form.Item
          className={formItemClasses}
          label={label}
          name={name}
          rules={rules}
          style={formItemStyles}
          validateStatus={validateStatus}
          help={help}
        >
          {type === 'password' ? (
            <Input.Password
              autoFocus={autoFocus}
              onFocus={onFocusHandler}
              onBlur={onBlurHandler}
              size="large"
              placeholder={placeholder}
              onChange={onChange}
              onKeyDown={onKeyDown}
              style={{ backgroundColor: 'transparent !important' }}
              disabled={disabled}
              value={value}
              iconRender={(visible: boolean) =>
                visible ? (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <EyeOutlined />
                  </div>
                ) : (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <EyeInvisibleOutlined />
                  </div>
                )
              }
              {...extra}
              ref={ref}
            />
          ) : (
            <Input
              autoFocus={autoFocus}
              onFocus={onFocusHandler}
              onBlur={onBlurHandler}
              size="large"
              placeholder={placeholder}
              onChange={onChange}
              onKeyDown={onKeyDown}
              disabled={disabled}
              value={value}
              type={type}
              {...extra}
              ref={ref}
            />
          )}
        </Form.Item>
        {subTextCustom ? <div className="subTextCustom">{subTextCustom}</div> : ''}
        {customFormError ? <div className="customFormError">{customFormError}</div> : ''}
      </div>
    )
  },
)

export default FormInput
